import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './Pages/HomePage';
import ServiceDetailPage from './Pages/ServiceDetailPage';
import ServicesListPage from './Pages/ServicesListPage';
import ServicePage from './Pages/ServicePage';
import ContactPage from './Pages/ContactPage';
import AboutPage from './Pages/AboutPage';
import PortfolioPage from './Pages/PortfolioPage';
import BlogPage from './Pages/BlogPage';
import BlogPostPage from './Pages/BlogPostPage';
import CareersPage from './Pages/CareersPage';
import FAQPage from './Pages/FAQPage';
import PricingPage from './Pages/PricingPage';
import PrivacyPage from './Pages/PrivacyPage';
import TermsPage from './Pages/TermsPage';
import { EntranceAnimationProvider } from './components/ui/PageEntranceAnimation';
import CookieConsent from './components/ui/CookieConsent';
import BackToTop from './components/ui/BackToTop';
import WolfChatbot from './components/ui/WolfChatbot';
import ScrollToTop from './components/ui/ScrollToTop';
import AiServicesPage from './Pages/AiServicesPage';

import './App.css';

function App() {
  // Set body background color
  React.useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.backgroundColor = '#F5F5F5';
    
    return () => {
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.body.style.backgroundColor = '';
    };
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <EntranceAnimationProvider>
          <div className="min-h-screen relative m-0 p-0" style={{ backgroundColor: '#F5F5F5' }}>
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServiceDetailPage />} />
            <Route path="/all-services" element={<ServicesListPage />} />
            <Route path="/service/:serviceId" element={<ServicePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/ai-services" element={<AiServicesPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
            <BackToTop />
            <CookieConsent />
            <WolfChatbot />
          </div>
        </EntranceAnimationProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;